import React from 'react'
import styles from './InfoBanner.module.scss'

/**
 * 정보 배너 컴포넌트
 * @param {string} title - 배너 제목
 * @param {string} description - 배너 설명 (줄바꿈 지원)
 * @param {string} className - 추가 CSS 클래스
 */
export const InfoBanner = ({ title, description, className = '' }) => {
	return (
		<div className={`${styles.infoBanner} ${className}`}>
			<div className={styles.bannerContent}>
				<div className={styles.bannerText}>
					<span className={styles.bannerTitle}>{title}</span>
					<pre className={styles.bannerSubtitle}>{description}</pre>
				</div>
			</div>
		</div>
	)
}
